import dayjs from 'dayjs';

export const validatePhoneNumber = (value) => {
  const phoneTest = /^[+\-0-9]+$/.test(value);
  const isValidPhoneNumber = phoneTest && value.length > 0;
  return isValidPhoneNumber;
};

export const PhoneNumber = (value) => {
  const phoneTest = /^[+\-0-9]+$/;
  if (phoneTest.test(value)) {
    console.log("Valid phone number:", value);
    return value; // Return the valid phone number
  }
};

export const formatCheckinDate = (dateString) => {
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", options).replace(",", "");
};

export const formatEventStartingDate = (timestamp) => {
  const options = { weekday: "long", month: "short", day: "numeric" };
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-US", options);
};

export const formatEventDateTime = (timestamp) => {
  const dateObj = new Date(timestamp);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Format date
  const formattedDate = `${dateObj.getDate()} ${
    months[dateObj.getMonth()]
  } ${dateObj.getFullYear()}`;

  // Format time
  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format and handle midnight (0 becomes 12)
  const formattedTime = `${hours}:${minutes}${ampm.toLowerCase()}`;

  return `${formattedDate} ${formattedTime}`;
};

export const formatEventDuration = (startTimestamp, endTimestamp) => {
  const startDate = new Date(startTimestamp);
  const endDate = new Date(endTimestamp);

  const durationMs = endDate - startDate;

  const seconds = Math.floor((durationMs / 1000) % 60);
  const minutes = Math.floor((durationMs / (1000 * 60)) % 60);
  const hours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
  const days = Math.floor(durationMs / (1000 * 60 * 60 * 24));

  let durationStr = "Dur: ";

  if (days > 0) {
    durationStr += `${days} day${days > 1 ? "s" : ""}`;
  } else if (hours > 0) {
    durationStr += `${hours} hour${hours > 1 ? "s" : ""}`;
  } else if (minutes > 0) {
    durationStr += `${minutes} minute${minutes > 1 ? "s" : ""}`;
  } else if (seconds > 0) {
    durationStr += `${seconds} second${seconds > 1 ? "s" : ""}`;
  } else {
    durationStr += "less than a second";
  }

  return durationStr;
};

export const validateTicket = (endDate) => {
  const currentDate = new Date();
  const targetDate = new Date(endDate);
  currentDate.setHours(0, 0, 0, 0);
  targetDate.setHours(0, 0, 0, 0);
  return currentDate <= targetDate;
};

export const handleOffers = (rate, offer) => {
  const discountedRate = (rate - (rate * offer) / 100).toFixed(2);
  return discountedRate;
};

export const correctTimeDate = (date) => {
  const bookingDate = new Date(date);

  // Adjusting the time by 5 hours and 30 minutes
  bookingDate.setHours(bookingDate.getHours() + 5);
  bookingDate.setMinutes(bookingDate.getMinutes() + 30);

  // Formatting the date and time
  const day = String(bookingDate.getDate()).padStart(2, "0");
  const month = String(bookingDate.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const year = bookingDate.getFullYear();

  let hours = bookingDate.getHours();
  const minutes = String(bookingDate.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert to 12-hour format

  const formattedDate = `${day}-${month}-${year} at ${hours}:${minutes}${ampm}`;
  return formattedDate;
};

export const setRoomNoAndPhoneNo = (room, phone) => {
  if (room) {
    localStorage.setItem("request_room_no", room);
  }
  if (phone) {
    localStorage.setItem("request_phone_no", phone);
  }
};

export const removePhoneAndMobileno = (room, phone) => {
  if (room) {
    localStorage.removeItem("request_room_no");
  }
  if (phone) {
    localStorage.removeItem("request_phone_no");
  }
};

export const fetchRoomNoAndPhoneNo = () => {
  var data = {
    phone: localStorage.getItem("request_phone_no")
      ? localStorage.getItem("request_phone_no")
      : "",
    room: localStorage.getItem("request_room_no")
      ? localStorage.getItem("request_room_no")
      : "",
  };
  return data;
};

export const setLoggedMobileNo = (phone) => {
  localStorage.setItem("loggedMobileNo", phone);
};

export const fetchLoggedMobileNo = () => {
  var phone = localStorage.getItem("loggedMobileNo")
    ? localStorage.getItem("loggedMobileNo")
    : "";
  return phone;
};

export const fetchEventLink = () => {
  var link = localStorage.getItem("redirectEventLink");
  return link;
};

export const setEventLinkRedirect = (link) => {
  localStorage.setItem("redirectEventLink", link);
};

export const showDates = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const dateArray = [];
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);

  while (start <= end) {
    if (start > today) {
      const isoDate = new Date(start).toISOString();

      const day = start.getDate();
      const month = start.toLocaleString("default", { month: "short" });
      const weekday = start.toLocaleString("default", { weekday: "long" });

      dateArray.push({
        date: isoDate,
        day: `${day} ${month} ${weekday}`,
        shortDay: `${day} ${month}`,
      });
    }

    start.setDate(start.getDate() + 1);
  }

  return dateArray;
};

export const extractTimeFromDate = (inputDate) => {
  const dateObj = new Date(inputDate);

  const day = dateObj.getDate();
  const month = dateObj.toLocaleString("default", { month: "short" });

  let hours = dateObj.getHours();
  const minutes = dateObj.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const time = `${hours}:${minutes} ${ampm}`;

  return time;
};

export const extractDatesfromArray = (dateArray, from_time) => {
  const timeString = new Date(from_time).toTimeString().split(" ")[0]; // HH:MM:SS

  const formattedDates = dateArray.map((item) => {
    const combinedDateTime = new Date(`${item.date}T${timeString}`);

    const datePart = new Date(item?.date).toISOString().split("T")[0]; // "2024-10-24"

    const stringDate = `${datePart}T${timeString}Z`;

    // Convert to UTC ISO format

    const dateObj = new Date(item.date);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    var obj = {
      day: `${day} ${month}`,
      remainingTicket: item?.remainingTicket,
      date: item.date, // new Date(stringDate).toISOString(),
      active: combinedDateTime > new Date(),
    };
    return obj;
  });
  return formattedDates;
};

export const formatPromotionDate = (date) => {
  var dateArray = date.split("-");
  var formatedDate = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
  return formatedDate;
};

export const formatTicketdate = (timestamp) => {
  const date = new Date(timestamp);

 
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

 
  const day = String(date.getDate()).padStart(2, "0");
  const month = months[date.getMonth()];
  const year = String(date.getFullYear()).slice(-2);

 
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12 || 12; 


  const formattedDate = `${day} ${month} ${year}`;
  const formattedTime = `${hours}:${minutes}${ampm}`;

  return `${formattedDate} at ${formattedTime}`;
};

export const checkPastTime = (date, time) => {
  const [year, month, day] = date.split("-").map(Number);
  const [hour, minute, second] = time.split(":").map(Number);
  const dateTime = new Date(year, month - 1, day, hour, minute, second);
  const now = new Date();
  const tolerance = 2000;
  return dateTime.getTime() < now.getTime() - tolerance;
};

export const dateFormater = (dateStr) => {
  const dateObj = new Date(dateStr);
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const formattedDate = `${dateObj.getDate()} ${months[dateObj.getMonth()]} ${dateObj.getFullYear() % 100}`;
console.log("converted date:==========",formattedDate)
   return formattedDate
};

export const convert_24_to_12 = (time) => {
  const [hours, minutes] = time.split(":");
  const hour = parseInt(hours, 10);
  const suffix = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12; // Convert 0 to 12 for 12 AM
  return `${hour12}:${minutes} ${suffix}`;
};


  export const checkPastTimeAndMinMaxTime = (date, time,minTime,maxTime) => {
    const [year, month, day] = date.split("-").map(Number);
    const [hour, minute, second] = time.split(":").map(Number);
    const dateTime = new Date(year, month - 1, day, hour, minute, second);
    const now = new Date();
    const tolerance = 2000;
    const is_past = dateTime.getTime() < (now.getTime() - tolerance);
    console.log("is_past=======================",is_past)
    const timeToMinutes = (time) => {
      if (typeof time !== "string" || !time.includes(":")) {
          console.error(`Invalid time format: ${time}`);
          return NaN;
      }
      const [hours, minutes] = time.split(":").map(Number);
      if (isNaN(hours) || isNaN(minutes)) {
          console.error(`Invalid time components in: ${time}`);
          return NaN;
      }
      return hours * 60 + minutes;
  };

  const selectedMinutes = timeToMinutes(time);
  const minMinutes = timeToMinutes(minTime);
  const maxMinutes = timeToMinutes(maxTime);

  if (isNaN(selectedMinutes) || isNaN(minMinutes) || isNaN(maxMinutes)) {
      console.error("One or more times could not be parsed.");
      return false;
  }

  console.log("Selected (minutes):", selectedMinutes);
  console.log("Min (minutes):", minMinutes);
  console.log("Max (minutes):", maxMinutes);

  let is_between;

  if (maxMinutes < minMinutes) {
      // Range spans midnight
      console.log("Range spans midnight");
      is_between = selectedMinutes >= minMinutes || selectedMinutes <= maxMinutes;
  } else {
      // Standard range
      console.log("Standard range");
      is_between = selectedMinutes >= minMinutes && selectedMinutes <= maxMinutes;
  }

  console.log("Is between:", is_between);
   let isValid = false;
    if (is_past === false && is_between === true) {
      isValid = false; // Either in the past or not within min-max range
    }else{
      isValid = true; // Valid time
    }
    console.log("isValid=========================",isValid)
  

    return isValid;
  };

  export const checkTwoDates = (firstDate,secondDate)=>{
    const firstDateParsed = new Date(firstDate.replace(" ", "T"));
    const secondDateParsed = new Date(secondDate);

    // Compare the dates
    if (firstDateParsed < secondDateParsed) {
         return true
    } else
    return false
    
  }

  export const CurrencySymbol = ()=>{
    const currency =   localStorage.getItem('hotelCurrency')
    switch (currency) {
      case "RS":
        return "₹";
      case "USD":
        return "$";
      default:
        return "₹";
    }
   };
   
